import React from "react";
import { NextSeo } from "next-seo";
import Button from "components/button";
import Loading from "components/loading";
import ErrorComponent from "components/error";
import Success from "components/success";
import Email from "components/email";
import { log } from "utils/sentry";
import { event } from "utils/gtag";

const initialMessage = {
  name: "",
  email: "",
  message: "",
  apikey: process.env.NEXT_PUBLIC_WEB3FORMS_KEY,
  subject: `Web Form Enquiry (${
    process.env.NEXT_PUBLIC_URL || process.env.NEXT_PUBLIC_VERCEL_URL
  })`,
};

export default function Contact() {
  const [message, setMessage] = React.useState(initialMessage);
  // idle, loading, success, error
  const [stage, setStage] = React.useState("idle");
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMessage({ ...message, [name]: value });
  };
  React.useEffect(() => {
    log("contact", "Entered Contact component.");
    return () => {
      log("contact", "Exited Contact component.");
    };
  }, []);
  const handleSubmit = async () => {
    log("contact", "Submitting contact form.", message);
    setStage("loading");
    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(message),
      });
      const json = await response.json();
      if (json.success) {
        log("contact", "Contact form submitted successfully.");
        event({
          action: "submit_form",
          category: "Contact",
          label: `${message.name}(${message.email})`,
        });
        setStage("success");
        setMessage({ ...initialMessage });
      } else {
        log("contact", "Something went wrong.", json);
        console.log("Something went wrong", json);
      }
    } catch (e) {
      console.log("ERROR IN CONTACT/HANDLESUBMIT", e);
      log("contact", "Error submitting contact form.", e, "Error");
      setStage("error");
    }
  };
  return (
    <>
      <NextSeo
        title="Contact"
        description="Let's chat! If you're interested in hiring me or just want to grab a coffee (in-person or over the internet), I'd love to hear from you."
      />
      <section
        id="contact"
        className="container flex flex-col items-center content-center justify-center"
      >
        <div className="flex items-center">
          <div className="container mx-auto">
            <div className="max-w-md py-8 mx-auto lg:py-12">
              {stage === "idle" && (
                <>
                  <div className="text-center">
                    <h1 className="text-4xl text-center xs:mb-4">
                      Let&apos;s chat!
                    </h1>
                    <p className="text-xl text-center">
                      If you&apos;re interested in hiring me or just want to
                      grab a coffee (in-person or over the internet), I&apos;d
                      love to hear from you.
                    </p>
                  </div>
                  <div className="m-7">
                    <form
                      onSubmit={(e) => {
                        setMessage({ ...message, sent: true });
                        e.preventDefault();
                        handleSubmit();
                      }}
                      action="https://api.web3forms.com/submit"
                      method="POST"
                      id="form"
                    >
                      <input
                        type="hidden"
                        name="apikey"
                        value={process.env.NEXT_PUBLIC_WEB3FORMS_KEY}
                      />
                      <input
                        type="hidden"
                        name="subject"
                        value="New Submission from Web3Forms"
                      />
                      <input
                        type="checkbox"
                        name="botcheck"
                        id=""
                        style={{ display: "none" }}
                      />
                      {/*   
                    <!-- Required: If submitting form without Javascript. 
                              Default web3forms output is in JSON format. -->
                    <!-- Not Required: If javascript, use "window.location.hash" instead --> 
                  */}
                      <input
                        type="hidden"
                        name="redirect"
                        value={`${
                          process.env.NEXT_PUBLIC_URL ||
                          process.env.NEXT_PUBLIC_VERCEL_URL
                        }/contact`}
                      />
                      <div className="mb-6">
                        <label htmlFor="name" className="block mb-2 text-sm">
                          Name
                        </label>
                        <input
                          onChange={handleInputChange}
                          type="text"
                          name="name"
                          id="name"
                          value={message.name}
                          placeholder="Joe Bloggs"
                          required
                          aria-required
                          className="w-full px-3 py-2 placeholder-gray-300 transition-colors border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500"
                        />
                      </div>
                      <div className="mb-6">
                        <label htmlFor="email" className="block mb-2 text-sm ">
                          Email
                        </label>
                        <input
                          onChange={handleInputChange}
                          type="email"
                          name="email"
                          id="email"
                          value={message.email}
                          placeholder="you@email.com"
                          required
                          aria-required
                          className="w-full px-3 py-2 placeholder-gray-300 transition-colors border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500"
                        />
                      </div>
                      <div className="mb-6">
                        <label
                          htmlFor="message"
                          className="block mb-2 text-sm "
                        >
                          Message
                        </label>

                        <textarea
                          onChange={handleInputChange}
                          rows="5"
                          name="message"
                          id="message"
                          value={message.message}
                          placeholder="Hey there!"
                          className="w-full px-3 py-2 placeholder-gray-300 transition-colors border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500"
                          required
                          aria-required
                        ></textarea>
                      </div>
                      <Button
                        aria-label="submit contact form"
                        type="submit"
                        size="base"
                        className="w-full"
                      >
                        Send Message
                      </Button>
                    </form>
                  </div>
                </>
              )}
              <p
                className="text-base text-center text-gray-400"
                id="result"
              ></p>
              {stage === "loading" && <Loading />}
              {stage === "success" && (
                <Success text="I'm so happy to hear from you! Please allow me a day or two to get back to you." />
              )}
              {stage === "error" && (
                <ErrorComponent>
                  <h3 className="text-3xl">
                    Hm, that didn&apos;t seem to work...
                  </h3>
                  <p className="text-2xl">
                    So sorry about that! You can also email me at <Email />.
                  </p>
                </ErrorComponent>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

// <form action="https://api.web3forms.com/submit" method="POST">

//   <!-- REQUIRED: Your Access key here. Don&apos;t worry this can be public -->
//   <input type="hidden" name="apikey" value="YOUR_ACCESS_KEY_HERE">

//   <!-- Optional: Subject an be prefilled using type="hidden"
//        or type="text" for normal user submitted input -->
//   <input type="hidden" name="subject" value="New Submission from Web3Forms">

//   <!-- Optional: To send the form submission as CC email -->
//   <input type="hidden" name="ccemail" value="partner@example.com">

//   <!-- Optional: Default replyto will be "email" (if available)
//        you may overwrite replyto with different email here -->
//   <input type="hidden" name="replyto" value="customer@example.com">

//   <!-- Required: If submitting form without Javascript.
//        Default web3forms output is in JSON format. -->
//   <!-- Not Required: If javascript, use "window.location.hash" instead -->
//   <input type="hidden" name="redirect" value="https://web3forms.com/success">

//   <!-- Optional: But Recommended: To Prevent SPAM Submission.
//        Make sure its hidden by default -->
//   <input type="checkbox" name="botcheck" class="hidden" style="display: none;">

//   <!-- COMING SOON: Google reCaptcha v3: To Prevent SPAM Submission.
//        This feature available to PRO Plan users only -->
//   <input type="hidden" name="recaptcha_response" id="recaptchaResponse">

//   <!-- Custom Form Data: Form data you wish to receive in email. -->
//   <input type="email" name="email" required>
//   <input type="text" name="First Name" required>
//   <input type="text" name="Phone Number" required>
//   <textarea name="message" required></textarea>

//   <button type="submit">Submit Form</button>

// </form>
